/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetStoreInfo: BridgeCommands.Command<
    {},
    Types.Gfn.Payment.StoreInfoResponse
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Payment',
    method: 'GetStoreInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProductsData: BridgeCommands.Command<
    Types.Gfn.Payment.GetProductsDataParameters,
    Types.Gfn.Payment.ProductsDataResponse
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Payment',
    method: 'GetProductsData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PurchaseSubscription: BridgeCommands.Command<
    Types.Gfn.Payment.PurchaseSubscriptionParameters,
    Types.Gfn.Payment.PurchaseProductResponse
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Payment',
    method: 'PurchaseSubscription',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPurchaseUpdates: BridgeCommands.Command<
    {},
    Types.Gfn.Payment.PurchaseUpdatesResponse
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Payment',
    method: 'GetPurchaseUpdates',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestorePurchases: BridgeCommands.Command<
    {},
    Types.Gfn.Payment.PurchaseUpdatesResponse
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Payment',
    method: 'RestorePurchases',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AcknowledgeFulfillment: BridgeCommands.Command<
    Types.Gfn.Payment.AcknowledgeFulfillmentParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Payment',
    method: 'AcknowledgeFulfillment',
    persistent: false
};

export const Payment = {
GetStoreInfo,
GetProductsData,
PurchaseSubscription,
GetPurchaseUpdates,
RestorePurchases,
AcknowledgeFulfillment
};
